import { render, staticRenderFns } from "./MyAddons.vue?vue&type=template&id=31289f7d"
import script from "./MyAddons.vue?vue&type=script&lang=js"
export * from "./MyAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports